import React, { PropTypes } from 'react';
import shallowEqual from 'recompose/shallowEqual';
import { assetAt } from 'utils/assets';

export default class AsyncImage extends React.Component {
  static propTypes = {
    small: PropTypes.string,
    src: PropTypes.string,
    raw: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    style: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      src: props.src,
      small: props.small,
    };

    this.imageLoaded = this.imageLoaded.bind(this);
  }

  shoudComponentUpdate(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }

  componentDidMount() {
    // const { image } = this.refs

    const { raw } = this.props;
    if (raw) {
      // Forcing thumbnail generation
      this.generateThumbnail(raw);
    }

    // if (image.complete) {
    //   this.setState({
    //     loaded: true
    //   })
    // } else {
    //   image.addEventListener('load', this.imageLoaded)
    // }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.src !== nextProps.src) {
      this.setState({
        src: nextProps.src,
      });
    }
  }

  generateThumbnail(file) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.setState({
          src: reader.result,
        });
      },
      false
    );

    reader.readAsDataURL(file);
  }

  imageLoaded() {
    this.setState({
      loaded: true,
    });
  }

  render() {
    const { className, style, onClick } = this.props;
    const { src } = this.state;

    return (
      <img
        ref="image"
        role="presentation"
        className={className}
        style={style}
        onClick={onClick}
        src={src || assetAt('images/placeholder.png')}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/AsyncImage.js